import { useEffect, useState } from "react";

const MOBILE_WIDTH = 900;

function checkMobile() {
  const regex =
    /iphone;|(ipad;)|(android|nokia|blackberry|bb10;).+mobile|android.+fennec|opera.+mobi|windows phone|symbianos/i;
  const isMobileByUa = regex.test(navigator.userAgent);
  const isIpad =
    navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
  const isTouchDevice = isTouchDeviceCheck();
  const isMobileByClientHint = (navigator as any).userAgentData?.mobile; // 型エラーを回避するため `as any` を使用

  return isMobileByClientHint || isMobileByUa || isIpad || isTouchDevice;
}

function isTouchDeviceCheck() {
  const isTouchDevice =
    "ontouchstart" in window || navigator.maxTouchPoints > 0;
  const isMobileScreen = window.matchMedia(
    "only screen and (max-width: 800px)"
  ).matches;
  return isTouchDevice && isMobileScreen;
}

export const useMobile = () => {
  const [isMobile, setIsMobile] = useState<boolean | null>(null);

  useEffect(() => {
    const handleResize = () => {
      const isMobileDevice = checkMobile();
      setIsMobile(isMobileDevice);
      //常に●●版としてふるまう。
      // setIsMobile(true);
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // 初期ロード時に判定

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return { isMobile };
};
